import { render, staticRenderFns } from "./StudentCriteria.vue?vue&type=template&id=978e2ac8"
import script from "./StudentCriteria.vue?vue&type=script&lang=js"
export * from "./StudentCriteria.vue?vue&type=script&lang=js"
import style0 from "./StudentCriteria.vue?vue&type=style&index=0&id=978e2ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports